<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">{{ $yuyanbao.boke }}</h1>
        </div>
      </div>

      <nav class="breadcrumb-nav mb-6">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.boke }}</li>
          </ul>
        </div>
      </nav>

      <div class="page-content mb-10">
        <div class="container">
          <el-row :gutter="20">
            <el-col v-for="(item, index) in blogs" :key="index" :xs="12" :sm="8" :lg="6">
              <div class="article-blog">
                <article class="article-blog-main post post-mask overlay-zoom br-sm" @click="
                  $router.push({
                    path: '/blogdetail',
                    query: { ukey: item.ukey },
                  })
                  ">
                  <figure class="post-media" style="height: 100%">
                    <img :src="item.tupian && item.tupian.length > 0
                      ? item.tupian[0]
                      : $tupianmoren
                      " style="
                        height: 100%;
                        object-fit: cover;
                        object-position: center;
                      " />
                  </figure>
                  <div class="post-details">
                    <div class="post-details-visible">
                      <h4 class="post-title text-white">{{ duoyuyan(item) }}</h4>
                    </div>
                    <div class="post-meta">
                      <span class="post-author">
                        {{ $shezhi.title1 }}
                      </span>
                      -
                      <span class="post-date">
                        {{ format_date(item.created) }}
                      </span>
                    </div>
                  </div>
                </article>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getJiHe } from "@/api/jihe";

export default {
  name: "Blog",
  components: {},
  data () {
    return {
      blogs: [],
      loading: false,
    };
  },
  mounted () {
    this.get_jihe_http();
  },
  methods: {
    get_jihe_http () {
      this.loading = true;
      getJiHe({ leixingukey: this.$shezhi.bokeukey })
        .then((data) => {
          if (data.status === "SUCCESSED") this.blogs = data.data;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
<style scoped>
.article-blog {
  transition: all 0.4s ease 0s;
  box-shadow: rgb(229 228 228) 0px 15px 40px 0px;
  cursor: pointer;
  padding-top: 100%;
  height: 0;
  position: relative;
  margin-bottom: 20px;
}

.article-blog-main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
@/api/jihe